import { IDeviceTypeResult, ProductItemsBasedOnDevice, VERTICAL_LIST_COUNT } from '../hooks/useDeviceType';
import { RecommendationType } from '../types/common';
import { Customer, UserRoles } from '../types/user.types';

const isSEButNotMkpOT = (isAssistedSalesSession: boolean, user: Customer | null) => {
  return (isAssistedSalesSession && user?.extras && user?.extras?.role?.code !== UserRoles.MKP_ORDER_TAKER) || false;
};

const checkIfMkpOT = (isAssistedSalesSession: boolean, user: Customer | null) => {
  return (isAssistedSalesSession && user?.extras && user?.extras?.role?.code === UserRoles.MKP_ORDER_TAKER) || false;
};

const getDeliverySlotSelection = (
  isAssistedSalesSession: boolean,
  user: Customer | null,
  enableDeliverySlotSelection: boolean,
): boolean => {
  return (
    user?.isCreditCustomer === true &&
    isAssistedSalesSession &&
    user?.extras?.role?.code !== UserRoles.MKP_ORDER_TAKER &&
    enableDeliverySlotSelection
  );
};

const getSM1UnavaiableReason = (
  isAssistedSalesSession: boolean,
  user: Customer | null,
  enableSM1UnavailableReason: boolean,
) => {
  return (isAssistedSalesSession && user?.isCreditCustomer && enableSM1UnavailableReason) || false;
};

const getProductsCountBasedOnDeviceType = (deviceType: IDeviceTypeResult, isVerticalScroll?: boolean) => {
  switch (deviceType.deviceType) {
    case 'mobile':
      return isVerticalScroll ? VERTICAL_LIST_COUNT : ProductItemsBasedOnDevice.mobile;
    case 'tablet':
      return isVerticalScroll ? VERTICAL_LIST_COUNT : ProductItemsBasedOnDevice.tablet;
    case 'desktop':
      return ProductItemsBasedOnDevice.desktop;
    default:
      return ProductItemsBasedOnDevice.tablet;
  }
};

const isFeatureEnabled = (minVersion: string | undefined, currentVersion: string): boolean => {
  if (!minVersion) return false;

  const normalizeVersion = (version: string) => version.match(/\d+/g)?.map(Number).join('.') || '0';

  return (
    normalizeVersion(currentVersion).localeCompare(normalizeVersion(minVersion), undefined, { numeric: true }) >= 0
  );
};

const getFeatureMinVersion = (
  countryCode: string,
  versionConfig: Record<string, string>,
): string | undefined => {
  return versionConfig?.[countryCode?.toUpperCase()];
};

const isDiversifyRecommendationsEnabled = (config: Record<string, any>, recommendationVariant: string): boolean => {
  if (!config || !recommendationVariant) return false;
  switch (recommendationVariant) {
    case RecommendationType.TOPPICKS:
    case RecommendationType.SEARCH_START_TOP_PICKS:
      return config?.diversifyTopPicks === 'true';
    case RecommendationType.RECOMMENDED_FOR_YOU:
    case RecommendationType.HOME_RECOMMENDATIONS:
      return config?.diversifyRecommendedForYou === 'true';
    case RecommendationType.BASKET_RECOMMENDATION:
      return config?.diversifyBasket === 'true';
    case RecommendationType.FRESHFOOD:
      return config?.diversifyFreshFood === 'true';

    default:
      return false;
  }
};

export {
  isSEButNotMkpOT,
  checkIfMkpOT,
  getDeliverySlotSelection,
  getSM1UnavaiableReason,
  getProductsCountBasedOnDeviceType,
  isFeatureEnabled,
  getFeatureMinVersion,
  isDiversifyRecommendationsEnabled,
};
  
